const validate = (values) => {
  const passwordRegex =
    /^(?=.*[A-Z])(?=.*[!~@#$%^&*;.)])(?=.*[0-9])(?=.*[a-z]).{8,}$/,
  errors = {};

  if (!values.password) {
    errors.password = {
      invalidLength: true,
      invalidUpper: true,
      invalidLower: true,
      invalidNumber: true,
      invalidSpecial: true,
    };
  } else if (!passwordRegex.test(values.password)) {
    const password = values.password;

    errors.password = {
      invalidLength: !/(?=.{8,})/i.test(password),
      invalidUpper: !/(?=.*[A-Z])/.test(password),
      invalidLower: !/(?=.*[a-z])/.test(password),
      invalidNumber: !/(?=.*[0-9])/i.test(password),
      invalidSpecial: !/(?=.*[~@#$^*()_+=[\]{}|\\,.?: -]*$)(?!.*[<>'"/;`%]])/i.test(password),
    };
  }

  if (!values.password_confirmation) {
    errors.password_confirmation = true;
  } else if (values.password !== values.password_confirmation) {
    errors.password_confirmation = true;
  }

  return errors;
}

export default validate;



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordPage/validate.js